export const MerchandisingProgramCategoryTypeEnumValue = {
  None: 0,
  QuarterlyVisits: 1,
  SeasonalChange: 10,
  TrainStaff: 20,
};

export default MerchandisingProgramCategoryTypeEnumValue;
